import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

import { LocalizedMessage } from '../../localizedMessagesService/interfaces';

// Данные перевозчика
export interface CarrierData {
  id: string;
  files: string[];
  default_name: string;
  localized_names: string[];
  localized_names_data: LocalizedMessage[];
}

export interface CarrierLoaderQueryResponse {
  items: CarrierData[];
}

/**
 * Запрос загрузки данных по перевозчикам
 */
export class CarrierLoaderQuery implements GraphQLQuery<null> {
  readonly query: any;

  readonly variables: null;

  constructor(ids?: any[]) {
    this.variables = null;
    this.query = gql`
            query LoadCarriers {
                items: carrier_list(
                    limit: 1000000
                    ${
                      ids && ids.length > 0
                        ? `where:{id:{_in: [${ids.map((id) => `"${id}"`).join(',')}]}}`
                        : ``
                    }
                ) {
                    id
                    files
                    default_name
                    localized_names
                }
            }
        `;
  }
}
